import { useEffect } from "react";
import api from "src/api/supportRequest";
import { useAppDispatch } from "src/redux/hooks";
import * as actions from "src/redux/slices/supportRequestSlice";

/** Refresh only the active conversation, without overlapping a send or fetch. */
export function useLiveSupportRequest(id: string | null, type: "admin" | "tenant", busy: boolean) {
  const dispatch = useAppDispatch();
  useEffect(() => {
    if (!id || busy) return;
    let stopped = false;
    let fetching = false;
    const refresh = async () => {
      if (stopped || fetching || document.visibilityState === "hidden") return;
      fetching = true;
      try {
        const response = await (type === "admin" ? api.getSupportRequestByIdAdmin(id) : api.getSupportRequestByIdTenant(id));
        if (!stopped) dispatch(type === "admin"
          ? actions.getSupportRequestByIdAdminSuccess(response.data)
          : actions.getSupportRequestByIdTenantSuccess(response.data));
      } catch {
        // Keep the current conversation visible while offline; retry later.
      } finally { fetching = false; }
    };
    const timer = window.setInterval(refresh, 3000);
    window.addEventListener("focus", refresh);
    document.addEventListener("visibilitychange", refresh);
    return () => {
      stopped = true;
      window.clearInterval(timer);
      window.removeEventListener("focus", refresh);
      document.removeEventListener("visibilitychange", refresh);
    };
  }, [id, type, busy, dispatch]);
}
